module.exports = __webpack_public_path__ + "resources/img/img_dataflow_m_jp.16cece21eba51a676f343ec4974d21a2.png";